import React from "react"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import "../assets/css/layout.css"

library.add(fab)

export default function Layout({ children }) {
  return <div>{children}</div>
}
